/* eslint-disable prefer-destructuring */
import React from "react";
import lod_ from "lodash";
import { selectNotifications, markNotificationAsRead } from "redux/reducers/notificationsReducer";
import notificationActions from "redux/actions/notificationActions";
import { useDispatch, useSelector } from "react-redux";
import NotificationItem from "components/NotificationItem";
import "./style.css";
import { handleNotificationClick } from "helpers/notifications";

/**
 * #######################################################@
 *
 * SnackBar component
 *
 * Used to display a message in a snackbar by the store
 *
 * #######################################################@
 */
const { Slide, Paper } = require("@mui/material");
const { useState, useEffect, useRef } = require("react");

const SnackBarMessage = () => {
	const dispatch = useDispatch();
	const notifications = useSelector(selectNotifications);

	const [notificationStack, setNotificationStack] = useState([]);
	const previousLengthRef = useRef(0);
	const timersRef = useRef({});

	useEffect(() => {
		const notificationItems = notifications.items ?? [];
		const lastAddedMethod = notifications.lastAddedMethod;

		// If no new notification added by websocket, ignore
		// It's to prevent showing toast on initial fetch or other actions
		if (lastAddedMethod !== "websocket") {
			previousLengthRef.current = notificationItems.length;
			return;
		}

		if (lod_.isNil(notificationItems) === true || notificationItems.length === 0) {
			previousLengthRef.current = 0;
			return;
		}

		// Détecter si une nouvelle notification a été ajoutée
		if (notificationItems.length > previousLengthRef.current) {
			const newNotification = notificationItems[0]; // Les nouvelles notifications sont en premier

			if (lod_.isNil(newNotification) === false) {
				const notificationId = newNotification.id || Date.now();

				// Ajouter la nouvelle notification au stack (max 5)
				setNotificationStack(prev => {
					const updated = [...prev, { ...newNotification, stackId: notificationId }];

					// Si on dépasse 5 notifications, retirer la plus ancienne
					if (updated.length > 5) {
						const removedNotification = updated.shift();
						// Nettoyer le timer de la notification retirée
						if (timersRef.current[removedNotification.stackId]) {
							clearTimeout(timersRef.current[removedNotification.stackId]);
							delete timersRef.current[removedNotification.stackId];
						}
					}

					return updated;
				});

				// Créer un timer pour cette notification spécifique
				const timer = setTimeout(() => {
					setNotificationStack(prev => prev.filter(n => n.stackId !== notificationId));
					delete timersRef.current[notificationId];
				}, 5000);

				timersRef.current[notificationId] = timer;

				previousLengthRef.current = notificationItems.length;
			}
		} else {
			previousLengthRef.current = notificationItems.length;
		}
	}, [notifications?.items]);

	// Nettoyer les timers au démontage du composant
	useEffect(() => {
		return () => {
			Object.values(timersRef.current).forEach(timer => clearTimeout(timer));
		};
	}, []);

	/**
	 * Gérer le clic sur la notification toast
	 */
	const notificationClick = notification => {
		handleNotificationClick(notification, dispatch);

		// Retirer la notification du stack
		setNotificationStack(prev => prev.filter(n => n.stackId !== notification.stackId));

		// Nettoyer le timer associé
		if (timersRef.current[notification.stackId]) {
			clearTimeout(timersRef.current[notification.stackId]);
			delete timersRef.current[notification.stackId];
		}
	};

	return (
		<div className="notificationsContainer">
			{notificationStack.map((notification, index) => (
				<Slide
					key={notification.stackId}
					in
					direction="up"
					style={{
						transformOrigin: "0 0 0"
					}}
				>
					<Paper
						elevation={6}
						sx={{
							borderRadius: 2,
							overflow: "hidden",
							minWidth: 320,
							maxWidth: 450,
							marginBottom: index < notificationStack.length - 1 ? 2 : 0
						}}
					>
						<NotificationItem
							id={notification.id}
							icon={notification.icon}
							message={notification.message}
							createdAt={notification.createdAt}
							severity={notification.severity}
							read={notification.read}
							popUp
							onClick={() => notificationClick(notification)}
						/>
					</Paper>
				</Slide>
			))}
		</div>
	);
};

export default SnackBarMessage;
